(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('ScheduleObjectTestController', ScheduleObjectTestController);

    ScheduleObjectTestController.$inject = ['$state', '$uibModalInstance', 'AlertService', '$timeout', 'entity'];

    function ScheduleObjectTestController($state, $uibModalInstance, AlertService, $timeout, entity) {
        var vm = this;

        vm.scheduleDate = entity;
        vm.testScheduleName = vm.scheduleDate.scheduleName;
        if(!entity.single)
            vm.multipleSchedule = entity.selectedDay;

        vm.afterLaunch = entity.afterLaunch;

        vm.multipleSchedule = [
            {day: "MON"},
            {day: "TUE"},
            {day: "WED"},
            {day: "THU"},
            {day: "FRI"},
            {day: "SAT"},
            {day: "SUN"}
        ];

        vm.repeatStatus = [false, false, false, false, false, false, false];

        vm.checkEmptyWeeklyForm = function () {
            var isEmpty = true;
            angular.forEach(vm.multipleSchedule, function(check){
                if(check.selectedTime){
                    isEmpty = false;
                }
            })
            return isEmpty;
        }

        vm.openTimeCal = function(index) {
            $timeout(function() {
                vm.repeatStatus[index] = true;
            });
        };

        vm.datepickerOptions = {
            minDate: null
        };

        vm.openUpCalendar = function (e) {
            e.preventDefault();
            e.stopPropagation();
            if (vm.scheduleUpDatetime) {
                vm.scheduleUpDatetime.isOpen = !vm.scheduleUpDatetime.isOpen;
            } else {
                vm.scheduleUpDatetime = {isOpen: true};
            }
        };

        vm.clear = function () {
            $uibModalInstance.dismiss('cancel');
        };

        vm.save = function () {
            vm.scheduleDate.testName = vm.testName;
            if(!vm.scheduleDate.single) {
                vm.scheduleDate.selectedDay = vm.multipleSchedule;
                checkAtLeastOneValue();
            }
            $uibModalInstance.close(vm.scheduleDate);
        };

        function checkAtLeastOneValue() {
            var res = false;
            angular.forEach(vm.scheduleDate.selectedDay, function(check) {
                if(check.selectedTime != null) {
                    res = true;
                }
            });
            if(!res)
                vm.scheduleDate.selectedDay = undefined;
        }

        vm.check = function (check) {
            vm.scheduleDate = {};
            vm.scheduleDate.single = check;
            if(!vm.scheduleDate.single) {
                vm.multipleSchedule = [
                    {day: "MON"},
                    {day: "TUE"},
                    {day: "WED"},
                    {day: "THU"},
                    {day: "FRI"},
                    {day: "SAT"},
                    {day: "SUN"}
                ];
                vm.datepickerOptions = {
                    minDate: null
                };
            } else {
                vm.multipleSchedule = [];
                vm.datepickerOptions = {
                    minDate: new Date()
                };
            }
        }
    }
})();
